import React, { FC, useState } from "react";
import Box from "../../../../shared/ui/display/Box";
import Paper from "../../../../shared/ui/display/Paper";
import AuthConfirmUserForm from "../AuthConfirmUserForm";
import useAuthConfirmUserForm from "./useAuthConfirmUserForm";
import useForm from "./useForm";

export type AuthConfirmUserFormContainerProps = {
  phoneNumber: string;
  email: string;
  phoneType?: "primary" | "additional";
};

const AuthConfirmUserFormContainer: FC<AuthConfirmUserFormContainerProps> = ({
  phoneNumber,
  email,
  phoneType,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const formik = useForm({
    email,
    handleError: setErrorMessage,
  });

  const props = useAuthConfirmUserForm({
    formik,
    phoneNumber,
    email,
    phoneType,
    errorMessage,
    handleError: setErrorMessage,
  });

  return (
    <Paper>
      <Box p={6}>
        <AuthConfirmUserForm {...props} />
      </Box>
    </Paper>
  );
};

export default AuthConfirmUserFormContainer;
